/* kh-momentum.js — KH 2026-10-07
   Scorrimento orizzontale FLUIDO + inerzia (flick) GLOBALE, su ogni pagina del tema.
   Attacca il momentum a ogni carosello free-scroll target (presente o aggiunto dopo via API/JS),
   con GUARDIA anti-doppione: NON tocca i caroselli che hanno gia' un handler proprio
   (effect grid, featured, recently viewed, categorie -> flag _khTouchInit/_khMom/rv*).
   Per coprire un nuovo carosello: dargli classe .fx-related-carousel oppure attributo data-kh-momentum.
   Tuning attrito 0.95 (coast morbido); vel cappata a 2.5 px/ms. */
(function () {
  'use strict';

  function attach(el) {
    if (!el || el.__khMom || el._khTouchInit || el._khMom) return;
    el.__khMom = true;
    el.style.webkitOverflowScrolling = 'touch';
    el.style.touchAction = 'pan-x pan-y';
    el.style.overscrollBehaviorX = 'contain';

    var sx = 0, sy = 0, ss = 0, act = false, horiz = null, lastX = 0, lastT = 0, vel = 0, raf = 0;

    function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function inertia() {
      raf = requestAnimationFrame(function () {
        var max = el.scrollWidth - el.clientWidth;
        el.scrollLeft += vel * 16;
        vel *= 0.95;
        if (el.scrollLeft <= 0 || el.scrollLeft >= max || Math.abs(vel) < 0.03) { raf = 0; return; }
        inertia();
      });
    }

    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      stop();
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; ss = el.scrollLeft;
      act = true; horiz = null; lastX = sx; lastT = e.timeStamp; vel = 0;
      el.style.scrollBehavior = 'auto';
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!act || e.touches.length !== 1) return;
      var cx = e.touches[0].clientX, dx = sx - cx, dy = sy - e.touches[0].clientY;
      if (horiz === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) horiz = Math.abs(dx) > Math.abs(dy);
      if (horiz) {
        e.preventDefault();
        el.scrollLeft = ss + dx;
        var dt = e.timeStamp - lastT;
        if (dt > 0) { var v = (lastX - cx) / dt; vel = vel * 0.4 + v * 0.6; }
        lastX = cx; lastT = e.timeStamp;
      }
    }, { passive: false });

    el.addEventListener('touchend', function () {
      act = false;
      if (horiz && Math.abs(vel) > 0.08) { if (vel > 2.5) vel = 2.5; if (vel < -2.5) vel = -2.5; inertia(); }
    }, { passive: true });
  }

  window.khMomentum = attach;

  var SEL = '.fx-related-carousel, [data-kh-momentum]';
  function scan() { try { document.querySelectorAll(SEL).forEach(attach); } catch (e) {} }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  /* caroselli aggiunti dopo (es. raccomandazioni via API) -> ri-scan debounced */
  var pending = false;
  try {
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
